import {RiDeleteBinLine} from 'react-icons/ri'
import {  MwSwitch } from '../ui';
import {BiEdit} from 'react-icons/bi'
import { usePut } from '../../hooks';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

const PaymentMethodList = ({data,loading,currentLangId ,confirmDeleteHandler,editHandler, treasuriesData}) => {
    const {data:dataUpdate,loading:loadingUpdate,putData:putData} = usePut();
    const treasuries = treasuriesData?.data || treasuriesData || [];
    const treasuryNameById = treasuries.reduce((acc, treasury) => {
        if (!treasury?.id) return acc;
        acc[String(treasury.id)] = currentLangId === 'ar' ? treasury?.name_ar : treasury?.name_en;
        return acc;
    }, {});

    const {t} = useTranslation("global")
    
    // Create state for toggle values
    const [toggleStates, setToggleStates] = useState(
        data.reduce((acc, item) => {
            acc[String(item?.id)] = item?.is_active || false;
            return acc;
        }, {})
    );

    const onChangeSwitch = (item) => {
        console.log(item);
        // Update local state
        setToggleStates(prev => ({
            ...prev,
            [String(item.key)]: item.value
        }));
        
        const _data = {
            "isActive" : Boolean(item.value),
        }
        putData(`${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/payment-methods/update/${item.key}`,_data)

    }    

    const list = data.map((item,index) => {
        const treasuryId = item?.treasurie_id || item?.treasury_id;
        const treasuryName = item?.treasury_name || item?.treasurie_name || treasuryNameById[String(treasuryId)] || '';
        const relevantDescription =
            item?.description?.find((description) => description?.lang === currentLangId) ||
            (item?.description?.length ? item.description[0] : null);
        return (
            <div key={item?.id || index} className={`w-full`}>
                {relevantDescription &&
                <div className={`flex flex-col  text-xs mt-3  ${ data?.length -1 !== index  ? `border-b` : ``}`}>
                    <div className='flex justify-between items-center'>
                        <div>{relevantDescription?.name}</div>
                        <div className='flex flex-col items-center gap-2'>
                            <MwSwitch 
                                onChangeSwitch={onChangeSwitch} 
                                isActive={toggleStates[String(item?.id)] || false} 
                                setIsActive={(value) => setToggleStates(prev => ({
                                    ...prev,
                                    [String(item?.id)]: value
                                }))}
                                custKey={item?.id} 
                            />
                        </div>
                    </div>
                    <div className='flex justify-between  text-slate-500' >
                        <div>{relevantDescription?.desc}</div>
                        <div className='flex   pt-2'>
                            <BiEdit onClick={ () => editHandler(item)} size={14} className='my-2' />
                            <RiDeleteBinLine onClick={ () => confirmDeleteHandler(item)} size={14} className='m-2'/>
                        </div>
                        </div>
                    {treasuryName && <div className='text-[11px] text-slate-400 py-1'>الخزينة: {treasuryName}</div>}
                    
                </div>}
            </div>
        )
    });

    return (
        <div>
            
            <div className='text-sm font-semibold text-[#251658] my-3 px-1'>{t("setting.paymentMethodList")}</div>
            <div className='p-3  rounded-lg border border-slate-200'>{list}</div>
        </div>
    );
}

export default PaymentMethodList
